"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSsrMatchMedia = exports.breakpoints = exports.DeviceType = void 0;
const mediaQuery = require('css-mediaquery');
var DeviceType;
(function (DeviceType) {
    DeviceType["Mobile"] = "mobile";
    DeviceType["Tablet"] = "tablet";
    DeviceType["Desktop"] = "desktop";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
exports.breakpoints = {
    xsmall: '0px',
    small: '400px',
    medium: '600px',
    large: '1024px',
    xlarge: '1280px',
};
const deviceTypeToBreakpointMap = {
    [DeviceType.Mobile]: exports.breakpoints.xsmall,
    [DeviceType.Tablet]: exports.breakpoints.medium,
    [DeviceType.Desktop]: exports.breakpoints.large,
};
const getSsrMatchMedia = (deviceType = DeviceType.Desktop) => {
    const width = deviceTypeToBreakpointMap[deviceType];
    return (query) => ({
        matches: mediaQuery.match(query, {
            width,
            type: 'screen',
        }),
    });
};
exports.getSsrMatchMedia = getSsrMatchMedia;
//# sourceMappingURL=responsive.js.map